// @flow

import { beginRequest, completeRequest } from "@store/utils";

import type { AbsenceReasonsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetAbsenceReasons = (state: AbsenceReasonsState) => () => startRequest(state);

export const onGetAbsenceReasonsSuccess = (state: AbsenceReasonsState) => ({ payload }: any) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  options: {
    ...state.options,
    absenceReasons: payload,
  },
});

export const onGetAbsenceReasonsError = (state: AbsenceReasonsState) => ({ payload }: any) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
});
